import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TrackClickDirective } from '../../directives/track-click.directive';

export interface ReportsCardTracking {
  trackEvent?: string;
  trackCategory?: string;
  trackLabel?: string;
}

@Component({
  selector: 'app-reports-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    TrackClickDirective
  ],
  templateUrl: './reports-card.html',
  styleUrls: ['./reports-card.scss']
})
export class ReportsCard {
  @Input() borderColor: string = '#e0e0e0';
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() cardId: string = '';
  @Input() isCollapsed: boolean = false;

  // NOVOS INPUTS para tracking dinâmico
  @Input() trackingConfig: ReportsCardTracking = {
    trackEvent: 'reports_card_click',
    trackCategory: 'dashboard',
    trackLabel: 'ver_mais'
  };

  @Output() seeMoreClicked = new EventEmitter<string>();

  onSeeMoreClick(): void {
    this.seeMoreClicked.emit(this.cardId);
  }

  // Métodos para tracking dinâmico
  getTrackingEvent(): string {
    return this.trackingConfig.trackEvent || 'reports_card_click';
  }

  getTrackingCategory(): string {
    return this.trackingConfig.trackCategory || 'dashboard';
  }

  getTrackingLabel(): string {
    const baseLabel = this.trackingConfig.trackLabel || 'ver_mais';
    // Adiciona o título do card para identificar qual foi clicado
    return `${baseLabel}_${this.title.toLowerCase().replace(/[^a-z0-9]/g, '_')}`;
  }
}
